// Keep the sign-in page covered until redirect recovery, role enrolment,
// refreshed claims and the account profile have all settled.
export function subscribeAccountReadiness({onUser,onLoading=()=>{},resolveRedirect,watchAuth,currentUser,watchProfile,enrolGoogle,signOut,isAdminPath=()=>false}) {
  let epoch=0,closed=false,stopProfile=()=>{};
  const active=version=>!closed&&version===epoch;
  const finish=(version,profile,error)=>{if(!active(version))return;onUser(profile,error);onLoading(false);};
  onLoading(true);
  let redirectError;
  const redirect=Promise.resolve().then(resolveRedirect).catch(error=>{redirectError=error;});
  const stopAuth=watchAuth(async user=>{
    if(closed)return;
    const version=++epoch;stopProfile();onLoading(true);
    await redirect;
    if(!active(version)||(currentUser()?.uid||null)!==(user?.uid||null))return;
    // A redirect-result lookup can fail after Auth has already restored a valid
    // user. Verify/enrol that authenticated account rather than strand it at
    // sign-in. A genuinely signed-out redirect failure remains visible.
    if(redirectError&&!user){const error=redirectError;redirectError=null;finish(version,null,error);return;}
    redirectError=null;
    if(!user){finish(version,null);return;}
    let google=false;
    try{
      google=(await user.getIdTokenResult()).signInProvider==='google.com';
      if(google)await enrolGoogle(user);
      if(!active(version))return;
      stopProfile=watchProfile(user.uid,async(profile,fromCache=false)=>{
        if(!active(version))return;
        // A cached miss is not proof that the just-created account is absent.
        if(!profile){if(fromCache)return;finish(version,null,new Error('Please sign in again to continue.'));return;}
        try{
          if(profile.role==='student'&&!google){finish(version,null,new Error('Sign in with your Google account to join a team.'));await signOut();return;}
          if(profile.role==='student'&&profile.teamId){
            const claims=(await user.getIdTokenResult()).claims;
            if(!active(version)||claims.teamId!==profile.teamId||claims.codeVersion!==profile.codeVersion)return;
          }
          if(profile.role==='student'&&isAdminPath()){finish(version,null,new Error('Use your @creatogether.app Google account to open Admin.'));return;}
          finish(version,profile);
        }catch(error){finish(version,null,error);}
      },error=>finish(version,null,error));
    }catch(error){
      if(!active(version))return;
      finish(version,null,error);
      if(error.code==='functions/permission-denied')try{await signOut();}catch(signOutError){finish(version,null,signOutError);}
    }
  },error=>finish(epoch,null,error));
  return()=>{closed=true;++epoch;stopProfile();stopAuth();};
}
